
$(document).ready(function() {
  updateModel()
    $(document).on('change', '.variant-picker__option-values input', function () {
      updateModel();
      console.log('changed');
    });
  function updateModel(){
    var checkedValue = $('.variant-picker__option-values input:checked').attr('color-value');

        var blue = "https://cdn.shopify.com/3d/models/d81f9fc1292a9fe3/blue.glb";
        var black = "https://cdn.shopify.com/3d/models/1e7ed62bdc75c1f1/black.glb";
        var white = "https://cdn.shopify.com/3d/models/83f1848746be5e53/white_1.glb";
        var green = "https://cdn.shopify.com/3d/models/92510f3f8a583bc2/green.glb";

        if(checkedValue == 'Blue') {
            $('model-viewer').attr('src', blue);
        } else if(checkedValue == 'Black') {
            $('model-viewer').attr('src', black);
        } else if(checkedValue == 'White') {
            $('model-viewer').attr('src', white);
        } else if(checkedValue == 'Green') {
            $('model-viewer').attr('src', green);
        }
  }


  $('.camera_on').click(function(){
    $('.camera_on_inner').toggleClass('control_off');
    if ($('.camera_on_inner').hasClass('control_off')) {
        // Remove the camera-controls attribute
        $('model-viewer').removeAttr('camera-controls');
    } else {
        // Add the camera-controls attribute
        $('model-viewer').attr('camera-controls', '');
    }
  })

  if(window.outerWidth < 999) {
    $('model-viewer').removeAttr('camera-controls');
  }

  
});



/* -----------------------------------------------------------------------
   Direct checkout — skip cart on product pages
   After a successful "Add to cart", redirect straight to /checkout
   instead of opening the cart drawer. Fires on both the main ATC button
   and the sticky bar button since both use the same product-form.
   ----------------------------------------------------------------------- */
(function () {
  if (!window.themeVariables || window.themeVariables.settings.pageType !== 'product') return;

  // Rename "Add to cart" buttons to "Buy now" so the label matches the behaviour
  function relabelButtons() {
    document.querySelectorAll('button[type="submit"]').forEach(function (btn) {
      var label = btn.textContent.trim().toLowerCase();
      if (label === 'add to cart') {
        btn.textContent = 'Buy now';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relabelButtons);
  } else {
    relabelButtons();
  }

  // Re-run after variant switches (Impact re-renders the sticky bar)
  document.addEventListener('variant:change', relabelButtons);

  // Redirect to checkout after item is added to cart
  document.addEventListener('variant:add', function () {
    window.location.href = '/checkout';
  });
})();
